import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Atividade } from 'src/app/core/atividade';
import { Acesso } from '../../../../core/acesso';

@Component({
    selector: 'publico-alvo-atividade',
    templateUrl: './publico-alvo-atividade.component.html',
    styleUrls: ['./publico-alvo-atividade.component.css']
})
export class PublicoAlvoAtividadeComponent implements OnInit, AfterContentChecked {

    @Input() perfilAcesso: Acesso;

    @Input() oficina: Atividade;

    openFormCadastro = false;

    constructor(protected drc: ChangeDetectorRef) {
    }

    ngOnInit() {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }


    onGetAdicionar(evento) {
        this.openFormCadastro = evento;
    }

}
